import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTelegramPlane, FaAngleDoubleUp, FaGoogle, FaUserFriends } from 'react-icons/fa';
import Language_i18 from '../../js/useNationalLanguage.jsx';

// GIỮ NGUYÊN KHÔNG ĐỔI
const data_json = [
  { key: 'showusername', label: { vi: 'Xem tên tài khoản', en: 'View, change Username' }, onClick: (o) => () => o('showusername'), content: '👩🏻‍🦰', classes: 'p-2', wrapper: 'div' },
  { key: 'showpassword', label: { vi: 'Xem đổi mật khẩu', en: 'View, change Password' }, onClick: (o) => () => o('showpassword'), content: '🔑', classes: 'p-2', wrapper: 'div' },
  { key: 'showapikey', label: { vi: 'API Key', en: 'API Key' }, onClick: (o) => () => o('showapikey'), content: '📶', classes: 'p-2', wrapper: 'div' },
  { key: 'telegram', label: { vi: 'Kết nối telegram', en: 'Connect Telegram' }, link: '/reactapp/themsdt?app=showadview', icon: <FaTelegramPlane size={17} />, classes: 'p-2', wrapper: 'Link' },
  { key: 'logout', label: { vi: 'Đăng xuất', en: 'Logout' }, onClick: (_, lo) => lo, content: '⏻', classes: 'p-2', wrapper: 'div' },
  { key: 'upgrade', label: { vi: 'Thăng cấp tài khoản', en: 'Level Up Account' }, link: '/shop/plan?app=showadview', icon: <FaAngleDoubleUp size={17} />, classes: 'p-2', wrapper: 'Link' },
  { key: 'delete', label: { vi: 'Xóa tài khoản', en: 'Delete Account' }, onClick: (o) => () => o('delete'), content: '✖️', classes: 'p-2', wrapper: 'div' },
  { key: 'google', label: { vi: 'Kết nối google', en: 'Connect Google' }, onClick: (_, __, g) => g, icon: <FaGoogle size={17} />, classes: 'p-2', wrapper: 'div' },
  { key: 'referrals', label: { vi: 'Hust Media Affiliate', en: 'Refer Friends' }, link: '/shop/referrals/home', icon: <FaUserFriends size={17} />, classes: 'p-2', wrapper: 'Link' },
  { key: 'referrals', label: { vi: 'Hust Media Shop', en: 'Hust Media Shop' }, link: '/shop/accounts/sellers/settings/home', content: '🛒', classes: 'p-2', wrapper: 'Link' }
];

// ✔ MOBILE MENU
function ProfileMenuMobile({ openpicker, handleLogout, openGooglelogin, lang }) {
  const [selectedKey, setSelectedKey] = useState(null);

  return (
    <div className="mx-2 flex flex-col bg-white rounded-md shadow-md p-1 md:hidden border border-gray-200">
      {data_json.map(item => {
        const Wrapper = item.wrapper === 'Link' ? Link : 'button';

        const isSelected = selectedKey === item.key;

        const props = {
          className: `
            flex items-center gap-3 py-2.5 px-3 rounded-md transition-colors
            border border-gray-100
            ${isSelected ? 'bg-purple-300 text-white' : 'bg-white hover:bg-purple-100'}
          `,
          onClick: () => {
            if (item.onClick) item.onClick(openpicker, handleLogout, openGooglelogin)();
            setSelectedKey(item.key); // ⭐ giữ trạng thái màu
          }
        };

        if (item.link) props.to = item.link;

        const textLabel = item.label?.[lang] || item.label?.vi || '';

        return (
          <Wrapper key={item.key} {...props}>
            <div className="text-xl w-7 flex justify-center">{item.icon || item.content}</div>
            <span className={`text-sm font-medium ${isSelected ? 'text-white' : 'text-gray-800'}`}>
              {textLabel}
            </span>
          </Wrapper>
        );
      })}
    </div>
  );
}

// ✔ UI DESKTOP — có trạng thái chọn
function ProfileMenuDesktop({ openpicker, handleLogout, openGooglelogin, lang }) {
  const [selectedKeyDesktop, setSelectedKeyDesktop] = React.useState(null);

  const buildClasses = (isLink, extra, isSelected) => {
    return [
      'w-full', 'h-full',
      'flex', 'flex-col', 'items-center', 'justify-center',
      'gap-1', 'py-2', 'px-2',
      'transition-all', 'duration-150',
      'rounded-md',
      isSelected ? 'bg-purple-300 text-white' : 'bg-white/60',
      'backdrop-blur-sm', 'shadow-sm',
      'hover:bg-purple-100 active:bg-purple-200',
      isLink ? 'cursor-pointer' : 'cursor-default',
      extra || ''
    ].join(' ').trim();
  };

  return (
    <div
      className="
        grid
        grid-cols-3
        gap-1
        auto-rows-fr
        rounded-md
        divide-x divide-y divide-dashed
        bg-gradient-to-br from-gray-50 to-white
        dark:bg-gray-200
        m-2 mt-1
        p-1
        hidden md:grid
      "
    >
      {data_json.map(item => {
        const Wrapper = item.wrapper === 'Link' ? Link : 'div';
        const isLink = item.wrapper === 'Link';
        const isSelected = selectedKeyDesktop === item.key;

        const extraClasses = buildClasses(isLink, item.classes, isSelected);

        const props = {
          className: extraClasses,
          onClick: () => {
            if (item.onClick) item.onClick(openpicker, handleLogout, openGooglelogin)();
            setSelectedKeyDesktop(item.key); // ⭐ giữ trạng thái màu
          }
        };

        if (item.link) props.to = item.link;

        const textLabel = item.label[lang] || item.label.vi;

        return (
          <Wrapper key={item.key} {...props}>
            <div className="w-full h-full flex flex-col items-center justify-center">
              <div className="flex items-center justify-center">
                <div className="rounded-full w-5 h-5 flex items-center justify-center">
                  <div className={`text-xl ${isSelected ? 'text-white' : ''}`}>
                    {item.icon || item.content}
                  </div>
                </div>
              </div>
              <div className="mt-1 w-full text-center px-1">
                <div className={`text-base font-medium whitespace-normal break-words ${isSelected ? 'text-white' : 'text-gray-800'}`}>
                  {textLabel}
                </div>
              </div>
            </div>
          </Wrapper>
        );
      })}
    </div>
  );
}



// ✔ Component tổng — tự động chọn mobile/desktop
export default function ProfileMenu(props) {
  const { lang } = Language_i18();

  return (
    <>
      <ProfileMenuMobile {...props} lang={lang} />
      <ProfileMenuDesktop {...props} lang={lang} />
    </>
  );
}
